/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Font_SizeInputs */



/**
* | output |
* | --- |
* | "Metrics Font Size" |
*
* @param {Options_Metrics_Font_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_font_size = /** @type {((inputs?: Options_Metrics_Font_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Font_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "it") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "es") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Metrics Font Size")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Metrics Font Size")
	return /** @type {LocalizedString} */ ("Metrics Font Size")
});